export enum FilterUid {
  Categories = 'filter[subcategories][]',
  Colour = 'filter[attribute_values][12][]',
  Delivery = 'filter[delivery][]',
  DeliveryZones = 'filter[delivery_zone]',
  Discount = 'filter[discount][]',
  Personalisation = 'filter[personalisable]',
  Price = 'price',
  SpecialFeatures = 'filter[special][]',
}
